import * as immutable from "immutable";
import {IReportTemplateWorklistItem, IReportTemplateEditorConfig} from "../interfaces/report-template-worklist-item.interface";
import {IgenomicsAction} from "@ispm/core/interfaces/genomics-action.interface";
import {EDITOR_ACTIONS} from "./report-template.actions";

export interface IReportTemplateState {
  workList: immutable.List<IReportTemplateWorklistItem>
  editor: IReportTemplateEditorConfig
}

const InitState: IReportTemplateState = {
  workList: immutable.List(),
  editor : {
      'variables' : {},
      'jsonBase' : {}
  }
};

export function reportTemplateReducer(state: IReportTemplateState = InitState, action: IgenomicsAction): IReportTemplateState {
    let newState: IReportTemplateState;
    switch (action.type) {
        case EDITOR_ACTIONS.EDITOR_INIT:
            return InitState;
        case EDITOR_ACTIONS.SET_EDITOR_WORKLIST:
            newState = Object.assign({}, state);
            newState.workList = immutable.List(action.payload.results);
            return newState;
        case EDITOR_ACTIONS.SET_EDITOR_VARIABLES:
            newState = Object.assign({}, state);
            newState.editor.variables = action.payload;
            return newState;
    
        case EDITOR_ACTIONS.SET_EDITOR_JSON_BASE:
            newState = Object.assign({}, state);
            newState.editor.jsonBase = action.payload;
            return newState;
        
        default:
            return state;
    }
}